import { LoadingButton } from '@mui/lab';
import { alpha, Popover, Stack, Typography, useTheme } from '@mui/material';

import { Strings } from '@app/constants';

interface Props {
  openDeletePopup: HTMLElement | null;
  handleCloseDeletePopup: () => void;
  handleDelete: () => void;
  content: string;
  heading: string;
}
const DeletePopover = ({
  openDeletePopup,
  handleCloseDeletePopup,
  handleDelete,
  heading,
  content,
}: Props) => {
  const id = openDeletePopup ? 'simple-popover' : undefined;
  const open = Boolean(openDeletePopup);
  const theme = useTheme();

  return (
    <Popover
      id={id}
      open={open}
      onClose={handleCloseDeletePopup}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      sx={{
        '& .MuiPaper-root': {
          width: '300px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          p: 3,
          backgroundColor: alpha(theme.palette.error.contrastText, 0.2),
          backdropFilter: 'blur(10px)',
          borderRadius: '10px',
          boxShadow: theme.shadows[5],
        },
      }}
    >
      <Stack>
        <Typography sx={{ textAlign: 'center', color: theme.palette.grey[700], fontWeight: 600 }}>
          {heading}
        </Typography>
        <Typography sx={{ mt: 2, mb: 2 }}>{content}</Typography>
        <LoadingButton
          variant="contained"
          color="error"
          sx={{ bgcolor: 'error.dark' }}
          loading={false}
          onClick={handleDelete}
        >
          {Strings.button.delete}
        </LoadingButton>
      </Stack>
    </Popover>
  );
};

export { DeletePopover };
